import { render, staticRenderFns } from "./work-type-reports.vue?vue&type=template&id=21960368"
import script from "./work-type-reports.vue?vue&type=script&lang=js"
export * from "./work-type-reports.vue?vue&type=script&lang=js"
import style0 from "./work-type-reports.vue?vue&type=style&index=0&id=21960368&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports